import React, { useMemo } from 'react'

import { ResultDisplayProps } from '../../common'
import { NoMeetingResult } from '../../DefaultDisplay/View/NoMeetingResult'
import { AIResultStatus } from '@zocks-communications/client-sdk-js'
import { Divider } from '../../../../../../../components/Divider/Divider'
import { AdvisorReferralResult, AdvisorReferralRefereeResult, AdvisorReferralClientResult, mapAdvisorReferralResult, getReferralCountProps } from './utils'
import { DefaultResultDisplay } from '../../DefaultDisplay/DefaultResultDisplay'

export const AdvisorReferral: React.FC<ResultDisplayProps> = ({ aiResult, aiFeature, row, collapsed, setCollapsed }) => {
  const advisorReferralResult = useMemo(() => mapAdvisorReferralResult(aiResult), [aiResult])

  if (aiResult.status === AIResultStatus.NO_RESULT) {
    return <NoMeetingResult />
  }

  if (advisorReferralResult === null) {
    return <DefaultResultDisplay aiFeature={aiFeature} aiResult={aiResult} row={row} collapsed={collapsed} setCollapsed={setCollapsed} />
  }

  return (
    <div className={'d-flex flex-column gap-4 px-2 mt-2'}>
      {advisorReferralResult.map((item, index) => (
        <>
          <AdvisorReferralAdvisorItem item={item} />
          {index < advisorReferralResult.length - 1 ? <Divider /> : null}
        </>
      ))}
    </div>
  )
}

interface AdvisorReferralRefereeItemProps {
  item: AdvisorReferralRefereeResult
}

const AdvisorReferralRefereeItem: React.FC<AdvisorReferralRefereeItemProps> = ({ item }) => {
  const { name, email, phoneNumber, pastReferral, futureReferral } = item

  return (
    <>
      {pastReferral ? (
        <span className={'paragraph-medium'}>
          - Already referred to {name} (email: {email}, phone number: {phoneNumber})
        </span>
      ) : null}
      {futureReferral ? (
        <span className={'paragraph-medium'}>
          - Will refer to {name} (email: {email}, phone number: {phoneNumber})
        </span>
      ) : null}
    </>
  )
}

interface AdvisorReferralClientItemProps {
  item: AdvisorReferralClientResult
}

const AdvisorReferralClientItem: React.FC<AdvisorReferralClientItemProps> = ({ item }) => {
  const { name, referees } = item

  if (!referees.length) {
    return null
  }

  return (
    <div className={'d-flex flex-column gap-2'}>
      <span className={'paragraph-medium bold'}>{name}</span>
      {referees.map((refereeItem) => (
        <AdvisorReferralRefereeItem item={refereeItem} />
      ))}
    </div>
  )
}

interface AdvisorReferralAdvisorItemProps {
  item: AdvisorReferralResult
}

const AdvisorReferralAdvisorItem: React.FC<AdvisorReferralAdvisorItemProps> = ({ item }) => {
  const { name, clients } = item

  const { referralAskedCount, referralCount, referringClientCount } = getReferralCountProps(clients)

  return (
    <div className={'d-flex flex-column zocks-gap-1'}>
      <h5>{item.name}</h5>
      {!referralAskedCount && !referralCount ? (
        <span className={'paragraph-medium'}>{name} has not asked for or received any referrals.</span>
      ) : !referralCount ? (
        <span className={'paragraph-medium'}>{name} has asked for referrals, but has not received any.</span>
      ) : (
        <span className={'paragraph-medium'}>
          {name} received {referralCount} referrals from {referringClientCount} clients:
        </span>
      )}
      {clients.map((clientItem) => (
        <AdvisorReferralClientItem item={clientItem} />
      ))}
    </div>
  )
}
